import React, { useState, useEffect, useRef } from 'react';

const CustomInput = ({
    id,
    type = 'text',
    value,
    onChange,
    onBlur,
    className = '',
    placeholder,
    maxLength,
    autoFocus = false,
    onReturnDown,
    disabled = false,
    refInput,
    menuTitle,
    dataqa
}) => {
    const inputRef = refInput || useRef(null);
    const [inputValue, setInputValue] = useState(value || '');
    const [currentValue, setCurrentValue] = useState('');

    // Sync with props.value when it changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        if (currentValue === '') {
            setCurrentValue(inputValue);
        }
        setInputValue(newValue);
        onChange?.(e);
    };

    const handleBlur = (e) => {
        e.oldValue = currentValue;

        if (inputValue.trim() === '' && menuTitle) {
            const resetValue = menuTitle;
            setInputValue(resetValue);

            const syntheticEvent = {
                ...e,
                target: {
                    ...e.target,
                    value: resetValue
                }
            };
            onChange?.(syntheticEvent);
        }

        onBlur?.(e);
    };

    const handleFocus = (e) => {
        setCurrentValue(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13 && onReturnDown) {
            onReturnDown(e);
        }
    };

    const inputClassName = className;
    const qaAttr = dataqa || id;

    return (
        <input
            ref={inputRef}
            type={type}
            id={id}
            name={id}
            value={inputValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onKeyDown={handleKeyDown}
            maxLength={maxLength}
            placeholder={placeholder}
            className={inputClassName}
            autoFocus={autoFocus}
            disabled={disabled}
            data-qa={qaAttr}
            autoComplete="off"
        />
    );
};

export default CustomInput;
